/**
 * Database Petung Ijab (Pernikahan Tradisi Jawa)
 * Disarikan dari ijab_petung_cleaned.xlsx
 * PERHATIAN: Sistem Neptu di sini KHUSUS untuk Ijab, terpisah dari Neptu Kalender standar.
 */

export const NEPTU_IJAB_DINA = [
  {
    "dina": "Minggu",
    "neptu_dina_ijab": 5,
    "catatan": "Khusus petung ijab &#8212; bukan NEPTU app"
  },
  {
    "dina": "Senin",
    "neptu_dina_ijab": 4,
    "catatan": "Khusus petung ijab &#8212; bukan NEPTU app"
  },
  {
    "dina": "Selasa",
    "neptu_dina_ijab": 1,
    "catatan": "Khusus petung ijab &#8212; bukan NEPTU app"
  },
  {
    "dina": "Rabu",
    "neptu_dina_ijab": 6,
    "catatan": "Khusus petung ijab &#8212; bukan NEPTU app"
  },
  {
    "dina": "Kamis",
    "neptu_dina_ijab": 7,
    "catatan": "Khusus petung ijab &#8212; bukan NEPTU app"
  },
  {
    "dina": "Jumat",
    "neptu_dina_ijab": 3,
    "catatan": "Khusus petung ijab &#8212; bukan NEPTU app"
  },
  {
    "dina": "Sabtu",
    "neptu_dina_ijab": 2,
    "catatan": "Khusus petung ijab &#8212; bukan NEPTU app"
  }
];

export const NEPTU_IJAB_PASARAN = [
  {
    "pasaran": "Legi",
    "neptu_pasaran_ijab": 2,
    "catatan": "Khusus petung ijab &#8212; bukan NEPTU app"
  },
  {
    "pasaran": "Pahing",
    "neptu_pasaran_ijab": 3,
    "catatan": "Khusus petung ijab &#8212; bukan NEPTU app"
  },
  {
    "pasaran": "Pon",
    "neptu_pasaran_ijab": 4,
    "catatan": "Khusus petung ijab &#8212; bukan NEPTU app"
  },
  {
    "pasaran": "Wage",
    "neptu_pasaran_ijab": 5,
    "catatan": "Khusus petung ijab &#8212; bukan NEPTU app"
  },
  {
    "pasaran": "Kliwon",
    "neptu_pasaran_ijab": 6,
    "catatan": "Khusus petung ijab &#8212; bukan NEPTU app"
  }
];

export const IJAB_WUKU = [
  {
    "id": 1,
    "wuku": "Sinta",
    "kanggo_ijab": "Becik"
  },
  {
    "id": 2,
    "wuku": "Landep",
    "kanggo_ijab": "Ala"
  },
  {
    "id": 3,
    "wuku": "Wukir",
    "kanggo_ijab": "Becik"
  },
  {
    "id": 4,
    "wuku": "Kurantil",
    "kanggo_ijab": "Ala"
  },
  {
    "id": 5,
    "wuku": "Tolu",
    "kanggo_ijab": "Becik"
  },
  {
    "id": 6,
    "wuku": "Gumbreg",
    "kanggo_ijab": "Becik"
  },
  {
    "id": 7,
    "wuku": "Warigalit",
    "kanggo_ijab": "Becik"
  },
  {
    "id": 8,
    "wuku": "Warigagung",
    "kanggo_ijab": "Becik"
  },
  {
    "id": 9,
    "wuku": "Julungwangi",
    "kanggo_ijab": "Ala"
  },
  {
    "id": 10,
    "wuku": "Sungsang",
    "kanggo_ijab": "Becik"
  },
  {
    "id": 11,
    "wuku": "Galungan",
    "kanggo_ijab": "Ala"
  },
  {
    "id": 12,
    "wuku": "Kuningan",
    "kanggo_ijab": "Ala"
  },
  {
    "id": 13,
    "wuku": "Langkir",
    "kanggo_ijab": "Becik"
  },
  {
    "id": 14,
    "wuku": "Mandasiya",
    "kanggo_ijab": "Becik"
  },
  {
    "id": 15,
    "wuku": "Julungpujut",
    "kanggo_ijab": "Normal"
  },
  {
    "id": 16,
    "wuku": "Pahang",
    "kanggo_ijab": "Normal"
  },
  {
    "id": 17,
    "wuku": "Kuruwelut",
    "kanggo_ijab": "Normal"
  },
  {
    "id": 18,
    "wuku": "Marakeh",
    "kanggo_ijab": "Ala"
  },
  {
    "id": 19,
    "wuku": "Tambir",
    "kanggo_ijab": "Ala"
  },
  {
    "id": 20,
    "wuku": "Medangkungan",
    "kanggo_ijab": "Normal"
  },
  {
    "id": 21,
    "wuku": "Maktal",
    "kanggo_ijab": "Becik"
  },
  {
    "id": 22,
    "wuku": "Wuye",
    "kanggo_ijab": "Normal"
  },
  {
    "id": 23,
    "wuku": "Manahil",
    "kanggo_ijab": "Ala"
  },
  {
    "id": 24,
    "wuku": "Prangbakat",
    "kanggo_ijab": "Normal"
  },
  {
    "id": 25,
    "wuku": "Bala",
    "kanggo_ijab": "Normal"
  },
  {
    "id": 26,
    "wuku": "Wugu",
    "kanggo_ijab": "Becik"
  },
  {
    "id": 27,
    "wuku": "Wayang",
    "kanggo_ijab": "Normal"
  },
  {
    "id": 28,
    "wuku": "Kulawu",
    "kanggo_ijab": "Normal"
  },
  {
    "id": 29,
    "wuku": "Dukut",
    "kanggo_ijab": "Normal"
  },
  {
    "id": 30,
    "wuku": "Watugunung",
    "kanggo_ijab": "Becik"
  }
];

export const IJAB_SASI = [
  {
    "id": 1,
    "sasi_jawa": "Sura",
    "alias_sumber": "Suro",
    "padanan_hijriah": "Muharram",
    "kanggo_ijab": "Rusak ing Tembemburine",
    "status_tegese": "Ala"
  },
  {
    "id": 2,
    "sasi_jawa": "Sapar",
    "alias_sumber": "",
    "padanan_hijriah": "Safar",
    "kanggo_ijab": "Kekurangan lan Sugih Utang",
    "status_tegese": "Ala"
  },
  {
    "id": 3,
    "sasi_jawa": "Mulud",
    "alias_sumber": "",
    "padanan_hijriah": "Rabi'ul-Awwal",
    "kanggo_ijab": "Mati Salah Siji",
    "status_tegese": "Ala"
  },
  {
    "id": 4,
    "sasi_jawa": "Bakda Mulud",
    "alias_sumber": "Bakdomulud, Bakda Mulud",
    "padanan_hijriah": "Rabi'ul-Akhir",
    "kanggo_ijab": "Nemu Ujar Kang Alal ing Tembemburine",
    "status_tegese": "Ala"
  },
  {
    "id": 5,
    "sasi_jawa": "Jumadilawal",
    "alias_sumber": "",
    "padanan_hijriah": "Jumadil-Awwal",
    "kanggo_ijab": "Kerep Kemalingan lan Kapusan",
    "status_tegese": "Ala"
  },
  {
    "id": 6,
    "sasi_jawa": "Jumadilakir",
    "alias_sumber": "",
    "padanan_hijriah": "Jumadil-Akhir",
    "kanggo_ijab": "Sugih Emas Salaka",
    "status_tegese": "Becik"
  },
  {
    "id": 7,
    "sasi_jawa": "Rejeb",
    "alias_sumber": "",
    "padanan_hijriah": "Rajab",
    "kanggo_ijab": "Sugih Anak",
    "status_tegese": "Netral"
  },
  {
    "id": 8,
    "sasi_jawa": "Ruwah",
    "alias_sumber": "",
    "padanan_hijriah": "Sya'ban",
    "kanggo_ijab": "Rahayu Sakabehe",
    "status_tegese": "Becik"
  },
  {
    "id": 9,
    "sasi_jawa": "Pasa (Siyam)",
    "alias_sumber": "Pasa",
    "padanan_hijriah": "Ramadan",
    "kanggo_ijab": "Rahayu Sakabehe",
    "status_tegese": "Becik"
  },
  {
    "id": 10,
    "sasi_jawa": "Sawal",
    "alias_sumber": "",
    "padanan_hijriah": "Syawwal",
    "kanggo_ijab": "Kekurangan lan Sugih Utang",
    "status_tegese": "Ala"
  },
  {
    "id": 11,
    "sasi_jawa": "Sela (Dulkangidah)",
    "alias_sumber": "Sela, Dulkaidah",
    "padanan_hijriah": "Dzulqa'dah",
    "kanggo_ijab": "Geringen lan Kerep Padudon karo Sanak Kadange",
    "status_tegese": "Ala"
  },
  {
    "id": 12,
    "sasi_jawa": "Besar",
    "alias_sumber": "",
    "padanan_hijriah": "Dzulhijjah",
    "kanggo_ijab": "Bisa Sugih lan Nemu Karaharjan",
    "status_tegese": "Becik"
  }
];

export const IJAB_TAHUN_WINDU = [
  {
    "id": 1,
    "tahun_jawa": "Alip",
    "kanggo_ijab": "Jumadilakir lan Sela bakal Kalebo Wisa"
  },
  {
    "id": 2,
    "tahun_jawa": "Ehe",
    "kanggo_ijab": "Bakdamulud lan Pasa bakal kena Lara Balung"
  },
  {
    "id": 3,
    "tahun_jawa": "Jimawal",
    "kanggo_ijab": "Mulud lan Besar bakal kena lara Edan"
  },
  {
    "id": 4,
    "tahun_jawa": "Je",
    "kanggo_ijab": "Sura dan Sawal bakal Keli ing Banyu"
  },
  {
    "id": 5,
    "tahun_jawa": "Dal",
    "kanggo_ijab": "Ruwah bakal kena lara Basah"
  },
  {
    "id": 6,
    "tahun_jawa": "Be",
    "kanggo_ijab": "Sapar dan Rejeb bakal kena lara Rumat"
  },
  {
    "id": 7,
    "tahun_jawa": "Wawu",
    "kanggo_ijab": "Jumadilawal bakal kena Prakara kang Gedhe"
  },
  {
    "id": 8,
    "tahun_jawa": "Jumakir",
    "kanggo_ijab": "Mulud lan Besar bakal kesinungan lara"
  }
];

export const IJAB_WETON = [
  {
    "id": 1,
    "dina": "Minggu",
    "pasaran": "Pon",
    "neptu_dina_ijab": 5,
    "neptu_pasaran_ijab": 4,
    "neptu_jumlah_ijab": 9,
    "surasane_ijab": "Sanggar Waringin",
    "tegese_surasa_ijab": "Bisa Dadi Pangaubaning Keluwarga",
    "status_ringkas": "Becik"
  },
  {
    "id": 2,
    "dina": "Senin",
    "pasaran": "Wage",
    "neptu_dina_ijab": 4,
    "neptu_pasaran_ijab": 5,
    "neptu_jumlah_ijab": 9,
    "surasane_ijab": "Sanggar Waringin",
    "tegese_surasa_ijab": "Bisa Dadi Pangaubaning Keluwarga",
    "status_ringkas": "Becik"
  },
  {
    "id": 3,
    "dina": "Selasa",
    "pasaran": "Kliwon",
    "neptu_dina_ijab": 1,
    "neptu_pasaran_ijab": 6,
    "neptu_jumlah_ijab": 7,
    "surasane_ijab": "Kala Tinantang",
    "tegese_surasa_ijab": "Padudon",
    "status_ringkas": "Ala"
  },
  {
    "id": 4,
    "dina": "Rabu",
    "pasaran": "Legi",
    "neptu_dina_ijab": 6,
    "neptu_pasaran_ijab": 2,
    "neptu_jumlah_ijab": 8,
    "surasane_ijab": "Demang Kanduruan",
    "tegese_surasa_ijab": "Susah lan Lara - laranen",
    "status_ringkas": "Ala"
  },
  {
    "id": 5,
    "dina": "Kamis",
    "pasaran": "Pahing",
    "neptu_dina_ijab": 7,
    "neptu_pasaran_ijab": 3,
    "neptu_jumlah_ijab": 10,
    "surasane_ijab": "Satriya Sinarajo",
    "tegese_surasa_ijab": "Becik lan Rahayu",
    "status_ringkas": "Becik"
  },
  {
    "id": 6,
    "dina": "Jumat",
    "pasaran": "Pon",
    "neptu_dina_ijab": 3,
    "neptu_pasaran_ijab": 4,
    "neptu_jumlah_ijab": 7,
    "surasane_ijab": "Kala Tinantang",
    "tegese_surasa_ijab": "Padudon",
    "status_ringkas": "Ala"
  },
  {
    "id": 7,
    "dina": "Sabtu",
    "pasaran": "Wage",
    "neptu_dina_ijab": 2,
    "neptu_pasaran_ijab": 5,
    "neptu_jumlah_ijab": 7,
    "surasane_ijab": "Kala Tinantang",
    "tegese_surasa_ijab": "Padudon",
    "status_ringkas": "Ala"
  },
  {
    "id": 8,
    "dina": "Minggu",
    "pasaran": "Kliwon",
    "neptu_dina_ijab": 5,
    "neptu_pasaran_ijab": 6,
    "neptu_jumlah_ijab": 11,
    "surasane_ijab": "Macan Ketawan",
    "tegese_surasa_ijab": "Kisinan",
    "status_ringkas": "Ala"
  },
  {
    "id": 9,
    "dina": "Senin",
    "pasaran": "Legi",
    "neptu_dina_ijab": 4,
    "neptu_pasaran_ijab": 2,
    "neptu_jumlah_ijab": 6,
    "surasane_ijab": "Nuju Pati",
    "tegese_surasa_ijab": "Ala Banget",
    "status_ringkas": "Ala"
  },
  {
    "id": 10,
    "dina": "Selasa",
    "pasaran": "Pahing",
    "neptu_dina_ijab": 1,
    "neptu_pasaran_ijab": 3,
    "neptu_jumlah_ijab": 4,
    "surasane_ijab": "Satriya Sinarajo",
    "tegese_surasa_ijab": "Becik lan Rahayu",
    "status_ringkas": "Becik"
  },
  {
    "id": 11,
    "dina": "Rabu",
    "pasaran": "Pon",
    "neptu_dina_ijab": 6,
    "neptu_pasaran_ijab": 4,
    "neptu_jumlah_ijab": 10,
    "surasane_ijab": "Satriya Sinarajo",
    "tegese_surasa_ijab": "Becik lan Rahayu",
    "status_ringkas": "Becik"
  },
  {
    "id": 12,
    "dina": "Kamis",
    "pasaran": "Wage",
    "neptu_dina_ijab": 7,
    "neptu_pasaran_ijab": 5,
    "neptu_jumlah_ijab": 12,
    "surasane_ijab": "Nuju Pati",
    "tegese_surasa_ijab": "Ala Banget",
    "status_ringkas": "Ala"
  },
  {
    "id": 13,
    "dina": "Jumat",
    "pasaran": "Kliwon",
    "neptu_dina_ijab": 3,
    "neptu_pasaran_ijab": 6,
    "neptu_jumlah_ijab": 9,
    "surasane_ijab": "Sanggar Waringin",
    "tegese_surasa_ijab": "Bisa Dadi Pangaubaning Keluwarga",
    "status_ringkas": "Becik"
  },
  {
    "id": 14,
    "dina": "Sabtu",
    "pasaran": "Legi",
    "neptu_dina_ijab": 2,
    "neptu_pasaran_ijab": 2,
    "neptu_jumlah_ijab": 4,
    "surasane_ijab": "Satriya Sinarajo",
    "tegese_surasa_ijab": "Becik lan Rahayu",
    "status_ringkas": "Becik"
  },
  {
    "id": 15,
    "dina": "Minggu",
    "pasaran": "Pahing",
    "neptu_dina_ijab": 5,
    "neptu_pasaran_ijab": 3,
    "neptu_jumlah_ijab": 8,
    "surasane_ijab": "Demang Kanduruan",
    "tegese_surasa_ijab": "Susah lan Lara - laranen",
    "status_ringkas": "Ala"
  },
  {
    "id": 16,
    "dina": "Senin",
    "pasaran": "Pon",
    "neptu_dina_ijab": 4,
    "neptu_pasaran_ijab": 4,
    "neptu_jumlah_ijab": 8,
    "surasane_ijab": "Demang Kanduruan",
    "tegese_surasa_ijab": "Susah lan Lara - laranen",
    "status_ringkas": "Ala"
  },
  {
    "id": 17,
    "dina": "Selasa",
    "pasaran": "Wage",
    "neptu_dina_ijab": 1,
    "neptu_pasaran_ijab": 5,
    "neptu_jumlah_ijab": 6,
    "surasane_ijab": "Nuju Pati",
    "tegese_surasa_ijab": "Ala Banget",
    "status_ringkas": "Ala"
  },
  {
    "id": 18,
    "dina": "Rabu",
    "pasaran": "Kliwon",
    "neptu_dina_ijab": 6,
    "neptu_pasaran_ijab": 6,
    "neptu_jumlah_ijab": 12,
    "surasane_ijab": "Nuju Pati",
    "tegese_surasa_ijab": "Ala Banget",
    "status_ringkas": "Ala"
  },
  {
    "id": 19,
    "dina": "Kamis",
    "pasaran": "Legi",
    "neptu_dina_ijab": 7,
    "neptu_pasaran_ijab": 2,
    "neptu_jumlah_ijab": 9,
    "surasane_ijab": "Sanggar Waringin",
    "tegese_surasa_ijab": "Bisa Dadi Pangaubaning Keluwarga",
    "status_ringkas": "Becik"
  },
  {
    "id": 20,
    "dina": "Jumat",
    "pasaran": "Pahing",
    "neptu_dina_ijab": 3,
    "neptu_pasaran_ijab": 3,
    "neptu_jumlah_ijab": 6,
    "surasane_ijab": "Nuju Pati",
    "tegese_surasa_ijab": "Ala Banget",
    "status_ringkas": "Ala"
  },
  {
    "id": 21,
    "dina": "Sabtu",
    "pasaran": "Pon",
    "neptu_dina_ijab": 2,
    "neptu_pasaran_ijab": 4,
    "neptu_jumlah_ijab": 6,
    "surasane_ijab": "Nuju Pati",
    "tegese_surasa_ijab": "Ala Banget",
    "status_ringkas": "Ala"
  },
  {
    "id": 22,
    "dina": "Minggu",
    "pasaran": "Wage",
    "neptu_dina_ijab": 5,
    "neptu_pasaran_ijab": 5,
    "neptu_jumlah_ijab": 10,
    "surasane_ijab": "Satriya Sinarajo",
    "tegese_surasa_ijab": "Becik lan Rahayu",
    "status_ringkas": "Becik"
  },
  {
    "id": 23,
    "dina": "Senin",
    "pasaran": "Kliwon",
    "neptu_dina_ijab": 4,
    "neptu_pasaran_ijab": 6,
    "neptu_jumlah_ijab": 10,
    "surasane_ijab": "Satriya Sinarajo",
    "tegese_surasa_ijab": "Becik lan Rahayu",
    "status_ringkas": "Becik"
  },
  {
    "id": 24,
    "dina": "Selasa",
    "pasaran": "Legi",
    "neptu_dina_ijab": 1,
    "neptu_pasaran_ijab": 2,
    "neptu_jumlah_ijab": 3,
    "surasane_ijab": "Sanggar Waringin",
    "tegese_surasa_ijab": "Bisa Dadi Pangaubaning Keluwarga",
    "status_ringkas": "Becik"
  },
  {
    "id": 25,
    "dina": "Rabu",
    "pasaran": "Pahing",
    "neptu_dina_ijab": 6,
    "neptu_pasaran_ijab": 3,
    "neptu_jumlah_ijab": 9,
    "surasane_ijab": "Sanggar Waringin",
    "tegese_surasa_ijab": "Bisa Dadi Pangaubaning Keluwarga",
    "status_ringkas": "Becik"
  },
  {
    "id": 26,
    "dina": "Kamis",
    "pasaran": "Pon",
    "neptu_dina_ijab": 7,
    "neptu_pasaran_ijab": 4,
    "neptu_jumlah_ijab": 11,
    "surasane_ijab": "Macan Ketawan",
    "tegese_surasa_ijab": "Kisinan",
    "status_ringkas": "Ala"
  },
  {
    "id": 27,
    "dina": "Jumat",
    "pasaran": "Wage",
    "neptu_dina_ijab": 3,
    "neptu_pasaran_ijab": 5,
    "neptu_jumlah_ijab": 8,
    "surasane_ijab": "Demang Kanduruan",
    "tegese_surasa_ijab": "Susah lan Lara - laranen",
    "status_ringkas": "Ala"
  },
  {
    "id": 28,
    "dina": "Sabtu",
    "pasaran": "Kliwon",
    "neptu_dina_ijab": 2,
    "neptu_pasaran_ijab": 6,
    "neptu_jumlah_ijab": 8,
    "surasane_ijab": "Demang Kanduruan",
    "tegese_surasa_ijab": "Susah lan Lara - laranen",
    "status_ringkas": "Ala"
  },
  {
    "id": 29,
    "dina": "Minggu",
    "pasaran": "Legi",
    "neptu_dina_ijab": 5,
    "neptu_pasaran_ijab": 2,
    "neptu_jumlah_ijab": 7,
    "surasane_ijab": "Kala Tinantang",
    "tegese_surasa_ijab": "Padudon",
    "status_ringkas": "Ala"
  },
  {
    "id": 30,
    "dina": "Senin",
    "pasaran": "Pahing",
    "neptu_dina_ijab": 4,
    "neptu_pasaran_ijab": 3,
    "neptu_jumlah_ijab": 7,
    "surasane_ijab": "Kala Tinantang",
    "tegese_surasa_ijab": "Padudon",
    "status_ringkas": "Ala"
  },
  {
    "id": 31,
    "dina": "Selasa",
    "pasaran": "Pon",
    "neptu_dina_ijab": 1,
    "neptu_pasaran_ijab": 4,
    "neptu_jumlah_ijab": 5,
    "surasane_ijab": "Macan Ketawan",
    "tegese_surasa_ijab": "Kisinan",
    "status_ringkas": "Ala"
  },
  {
    "id": 32,
    "dina": "Rabu",
    "pasaran": "Wage",
    "neptu_dina_ijab": 6,
    "neptu_pasaran_ijab": 5,
    "neptu_jumlah_ijab": 11,
    "surasane_ijab": "Macan Ketawan",
    "tegese_surasa_ijab": "Kisinan",
    "status_ringkas": "Ala"
  },
  {
    "id": 33,
    "dina": "Kamis",
    "pasaran": "Kliwon",
    "neptu_dina_ijab": 7,
    "neptu_pasaran_ijab": 6,
    "neptu_jumlah_ijab": 13,
    "surasane_ijab": "Kala Tinantang",
    "tegese_surasa_ijab": "Padudon",
    "status_ringkas": "Ala"
  },
  {
    "id": 34,
    "dina": "Jumat",
    "pasaran": "Legi",
    "neptu_dina_ijab": 3,
    "neptu_pasaran_ijab": 2,
    "neptu_jumlah_ijab": 5,
    "surasane_ijab": "Macan Ketawan",
    "tegese_surasa_ijab": "Kisinan",
    "status_ringkas": "Ala"
  },
  {
    "id": 35,
    "dina": "Sabtu",
    "pasaran": "Pahing",
    "neptu_dina_ijab": 2,
    "neptu_pasaran_ijab": 3,
    "neptu_jumlah_ijab": 5,
    "surasane_ijab": "Macan Ketawan",
    "tegese_surasa_ijab": "Kisinan",
    "status_ringkas": "Ala"
  }
];

export const KAMUS_SURASA_IJAB = [
  {
    "id": 1,
    "sisa_mod": 1,
    "surasane_ijab": "Kala Tinantang",
    "tegese": "Padudon",
    "status_ringkas": "Ala"
  },
  {
    "id": 2,
    "sisa_mod": 2,
    "surasane_ijab": "Demang Kanduruan",
    "tegese": "Susah lan Lara-laranen",
    "status_ringkas": "Ala"
  },
  {
    "id": 3,
    "sisa_mod": 3,
    "surasane_ijab": "Sanggar Waringin",
    "tegese": "Bisa Dadi Pangaubaning Keluwarga",
    "status_ringkas": "Becik"
  },
  {
    "id": 4,
    "sisa_mod": 4,
    "surasane_ijab": "Satriya Sinarajo",
    "tegese": "Becik lan Rahayu",
    "status_ringkas": "Becik"
  },
  {
    "id": 5,
    "sisa_mod": 5,
    "surasane_ijab": "Macan Ketawan",
    "tegese": "Kisinan",
    "status_ringkas": "Ala"
  },
  {
    "id": 6,
    "sisa_mod": 0,
    "surasane_ijab": "Nuju Pati",
    "tegese": "Ala Banget",
    "status_ringkas": "Ala"
  }
];

export const IJAB_TANGGAL_JAWA = [
  {
    "tanggal_jawa": 1,
    "pakarti_tanggal_jawa": "Nihil",
    "tegese_status": "Becik"
  },
  {
    "tanggal_jawa": 2,
    "pakarti_tanggal_jawa": "Berhasil",
    "tegese_status": "Becik"
  },
  {
    "tanggal_jawa": 3,
    "pakarti_tanggal_jawa": "Tanpa Hasil",
    "tegese_status": "Ala"
  },
  {
    "tanggal_jawa": 4,
    "pakarti_tanggal_jawa": "Kesulitan Diperjalanan",
    "tegese_status": "Ala"
  },
  {
    "tanggal_jawa": 5,
    "pakarti_tanggal_jawa": "Mendapat Hasil",
    "tegese_status": "Becik"
  },
  {
    "tanggal_jawa": 6,
    "pakarti_tanggal_jawa": "Mendapat Rejeki",
    "tegese_status": "Becik"
  },
  {
    "tanggal_jawa": 7,
    "pakarti_tanggal_jawa": "Baik Sekali",
    "tegese_status": "Becik"
  },
  {
    "tanggal_jawa": 8,
    "pakarti_tanggal_jawa": "Jatuh Sakit",
    "tegese_status": "Ala"
  },
  {
    "tanggal_jawa": 9,
    "pakarti_tanggal_jawa": "Mendapat Halangan",
    "tegese_status": "Ala"
  },
  {
    "tanggal_jawa": 10,
    "pakarti_tanggal_jawa": "Untung dan Selamat",
    "tegese_status": "Becik"
  },
  {
    "tanggal_jawa": 11,
    "pakarti_tanggal_jawa": "Baik Dapat Untung",
    "tegese_status": "Becik"
  },
  {
    "tanggal_jawa": 12,
    "pakarti_tanggal_jawa": "Tidak Beruntung",
    "tegese_status": "Ala"
  },
  {
    "tanggal_jawa": 13,
    "pakarti_tanggal_jawa": "Baik Dapat Pijaman",
    "tegese_status": "Becik"
  },
  {
    "tanggal_jawa": 14,
    "pakarti_tanggal_jawa": "Baik Dapat Untung",
    "tegese_status": "Becik"
  },
  {
    "tanggal_jawa": 15,
    "pakarti_tanggal_jawa": "Baik dan Selamat",
    "tegese_status": "Becik"
  },
  {
    "tanggal_jawa": 16,
    "pakarti_tanggal_jawa": "Tidak Beruntung",
    "tegese_status": "Ala"
  },
  {
    "tanggal_jawa": 17,
    "pakarti_tanggal_jawa": "Rahayu dan Selamat",
    "tegese_status": "Becik"
  },
  {
    "tanggal_jawa": 18,
    "pakarti_tanggal_jawa": "Baik Dapat Untung",
    "tegese_status": "Becik"
  },
  {
    "tanggal_jawa": 19,
    "pakarti_tanggal_jawa": "Baik dan Selamat",
    "tegese_status": "Becik"
  },
  {
    "tanggal_jawa": 20,
    "pakarti_tanggal_jawa": "Sakit Diperjalanan",
    "tegese_status": "Ala"
  },
  {
    "tanggal_jawa": 21,
    "pakarti_tanggal_jawa": "Sedih Diperjalanan",
    "tegese_status": "Ala"
  },
  {
    "tanggal_jawa": 22,
    "pakarti_tanggal_jawa": "Rahayu dan Selamat",
    "tegese_status": "Becik"
  },
  {
    "tanggal_jawa": 23,
    "pakarti_tanggal_jawa": "Sial",
    "tegese_status": "Ala"
  },
  {
    "tanggal_jawa": 24,
    "pakarti_tanggal_jawa": "Baik Dapat Untung",
    "tegese_status": "Becik"
  },
  {
    "tanggal_jawa": 25,
    "pakarti_tanggal_jawa": "Sial",
    "tegese_status": "Ala"
  },
  {
    "tanggal_jawa": 26,
    "pakarti_tanggal_jawa": "Kesusahan",
    "tegese_status": "Ala"
  },
  {
    "tanggal_jawa": 27,
    "pakarti_tanggal_jawa": "Sial",
    "tegese_status": "Ala"
  },
  {
    "tanggal_jawa": 28,
    "pakarti_tanggal_jawa": "Baik Dapat Untung",
    "tegese_status": "Becik"
  },
  {
    "tanggal_jawa": 29,
    "pakarti_tanggal_jawa": "Baik Dapat Rahmat",
    "tegese_status": "Becik"
  },
  {
    "tanggal_jawa": 30,
    "pakarti_tanggal_jawa": "Baik Dapat Pijaman",
    "tegese_status": "Becik"
  }
];

export const REF_DUA_SISTEM_NEPTU = [
  {
    "sistem": "neptu_ijab",
    "nama": "Minggu (contoh di ijab_weton)",
    "nilai": "lihat per baris ijab_weton",
    "pemakaian": "Hanya petung surasa ijab"
  },
  {
    "sistem": "neptu_ijab",
    "nama": "&#8230;",
    "nilai": "&#8230;",
    "pemakaian": "Jangan dipakai untuk pitung jodoh / watak weton harian"
  },
  {
    "sistem": "neptu_app_weton",
    "nama": "Minggu",
    "nilai": 5,
    "pemakaian": "getDayInfo, pitung, karakter harian"
  },
  {
    "sistem": "neptu_app_weton",
    "nama": "Senin",
    "nilai": 4,
    "pemakaian": "idem"
  },
  {
    "sistem": "neptu_app_weton",
    "nama": "Selasa",
    "nilai": 3,
    "pemakaian": "idem"
  },
  {
    "sistem": "neptu_app_weton",
    "nama": "Rabu",
    "nilai": 7,
    "pemakaian": "idem"
  },
  {
    "sistem": "neptu_app_weton",
    "nama": "Kamis",
    "nilai": 8,
    "pemakaian": "idem"
  },
  {
    "sistem": "neptu_app_weton",
    "nama": "Jumat",
    "nilai": 6,
    "pemakaian": "idem"
  },
  {
    "sistem": "neptu_app_weton",
    "nama": "Sabtu",
    "nilai": 9,
    "pemakaian": "idem"
  },
  {
    "sistem": "neptu_app_weton",
    "nama": "Legi",
    "nilai": 5,
    "pemakaian": "idem"
  },
  {
    "sistem": "neptu_app_weton",
    "nama": "Pahing",
    "nilai": 9,
    "pemakaian": "idem"
  },
  {
    "sistem": "neptu_app_weton",
    "nama": "Pon",
    "nilai": 7,
    "pemakaian": "idem"
  },
  {
    "sistem": "neptu_app_weton",
    "nama": "Wage",
    "nilai": 4,
    "pemakaian": "idem"
  },
  {
    "sistem": "neptu_app_weton",
    "nama": "Kliwon",
    "nilai": 8,
    "pemakaian": "idem"
  }
];
